/* ==========================================================================
   HH YouTube-Style Photo Blog — Player & Playlist
   Slideshow with Ken Burns, per-photo timer, video support,
   dynamic content swapping, keyboard navigation.
   ========================================================================== */

(function () {
  'use strict';

  /* ── Guard: only run on YouTube blog page ── */
  var dataEl = document.getElementById('hh-yt-data');
  if (!dataEl) return;

  /* ── Helpers ── */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ── Parse article data ── */
  var articles = [];
  try {
    articles = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.warn('[hh-yt] Could not parse article data:', e);
    return;
  }

  if (!articles.length) return;

  /* ── Clean images arrays (remove empty strings, nulls) ── */
  articles.forEach(function (a) {
    a.images = (a.images || []).filter(function (url) {
      return url && typeof url === 'string' && url.trim() !== '';
    });
    /* If no body images and no video, use featured image as fallback */
    if (!a.images.length && !a.video && a.featured_image) {
      a.images = [a.featured_image];
    }
  });

  /* ── DOM refs ── */
  var slideA     = $('.hh-yt__slide--a');
  var slideB     = $('.hh-yt__slide--b');
  var videoEl    = $('.hh-yt__video');
  var progFill   = $('.hh-yt__progress-fill');
  var counter    = $('.hh-yt__counter');
  var timerEl    = $('.hh-yt__timer');
  var titleEl    = $('#hh-yt-title');
  var dateEl     = $('#hh-yt-date');
  var authorEl   = $('#hh-yt-author');
  var descWrap   = $('#hh-yt-desc');
  var descText   = $('#hh-yt-desc-text');
  var descToggle = $('#hh-yt-desc-toggle');
  var thumbstrip = $('#hh-yt-thumbstrip');
  var playBtn    = $('.hh-yt__ctrl-play');
  var prevBtn    = $('.hh-yt__ctrl-prev');
  var nextBtn    = $('.hh-yt__ctrl-next');
  var iconPlay   = $('.hh-yt__icon-play');
  var iconPause  = $('.hh-yt__icon-pause');
  var playlistItems = $$('.hh-yt__playlist-item');
  var playerEl   = $('.hh-yt__player');
  var autoplayBtn = $('#hh-yt-autoplay');

  /* ── State ── */
  var autoplayOn     = true; /* starts on by default */
  var currentArticle = -1;
  var currentSlide   = 0;
  var slideTimer     = null;
  var tickTimer      = null;
  var isPlaying      = false;
  var isVideoMode    = false;
  var SLIDE_DURATION = 5000; /* 5s per photo */
  var TICK_INTERVAL  = 50;   /* Update timer every 50ms for smooth progress */
  var slideElapsed   = 0;    /* ms elapsed on current slide */
  var activeLayer    = 'a';  /* which slide layer is visible */
  var KB_CLASSES     = ['kb-1', 'kb-2', 'kb-3', 'kb-4'];
  var lastKB         = -1;   /* track last KB to avoid repeating */
  var isMobile       = window.innerWidth <= 768;

  window.addEventListener('resize', function () {
    isMobile = window.innerWidth <= 768;
  });


  /* ====================================================================
     HELPERS
     ==================================================================== */

  function formatTime(ms) {
    var totalSec = Math.floor(ms / 1000);
    var min = Math.floor(totalSec / 60);
    var sec = totalSec % 60;
    return min + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function getRandomKB() {
    var idx;
    do {
      idx = Math.floor(Math.random() * KB_CLASSES.length);
    } while (idx === lastKB && KB_CLASSES.length > 1);
    lastKB = idx;
    return KB_CLASSES[idx];
  }

  function clearKB(el) {
    KB_CLASSES.forEach(function (c) { el.classList.remove(c); });
  }


  /* ====================================================================
     TIMER / PROGRESS (smooth per-photo countdown)
     ==================================================================== */

  function startTick() {
    stopTick();
    slideElapsed = 0;
    tickTimer = setInterval(function () {
      slideElapsed += TICK_INTERVAL;

      var article = articles[currentArticle];
      var totalImages = article.images.length || 1;
      var totalDuration = totalImages * SLIDE_DURATION;

      /* Per-slide progress within total */
      var slideStart = currentSlide * SLIDE_DURATION;
      var elapsed = slideStart + slideElapsed;

      /* Overall progress bar */
      var pct = Math.min((elapsed / totalDuration) * 100, 100);
      progFill.style.transition = 'none';
      progFill.style.width = pct + '%';

      /* Timer display: elapsed / total */
      if (timerEl) {
        timerEl.textContent = formatTime(elapsed) + ' / ' + formatTime(totalDuration);
      }

      /* Auto-advance when this slide's time is up */
      if (slideElapsed >= SLIDE_DURATION) {
        var images = article.images;
        if (currentSlide < images.length - 1) {
          showSlide(currentSlide + 1, images);
        } else if (autoplayOn && currentArticle < articles.length - 1) {
          /* Autoplay: advance to next article in playlist */
          loadArticle(currentArticle + 1);
        } else {
          /* Autoplay off (or last article): stop at the end */
          stopSlideshow();
          progFill.style.width = '100%';
        }
      }
    }, TICK_INTERVAL);
  }

  function stopTick() {
    if (tickTimer) {
      clearInterval(tickTimer);
      tickTimer = null;
    }
  }


  /* ====================================================================
     VIDEO MODE
     ==================================================================== */

  function enterVideoMode(videoUrl) {
    isVideoMode = true;
    /* Hide slides */
    slideA.classList.remove('is-active');
    slideB.classList.remove('is-active');
    clearKB(slideA);
    clearKB(slideB);

    /* Show video */
    if (videoEl) {
      videoEl.src = videoUrl;
      videoEl.classList.add('is-active');
      videoEl.play().catch(function () { /* autoplay blocked, user will click */ });
    }

    /* Hide thumbstrip */
    thumbstrip.classList.add('hh-yt__thumbstrip--hidden');

    /* Hide photo controls, counter */
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    if (counter) counter.style.display = 'none';
    if (timerEl) timerEl.style.display = 'none';

    /* Use video's own progress */
    stopTick();
    stopSlideshow();

    videoEl.addEventListener('timeupdate', onVideoProgress);
    videoEl.addEventListener('ended', onVideoEnded);
  }

  function exitVideoMode() {
    isVideoMode = false;
    if (videoEl) {
      videoEl.pause();
      videoEl.removeAttribute('src');
      videoEl.classList.remove('is-active');
      videoEl.removeEventListener('timeupdate', onVideoProgress);
      videoEl.removeEventListener('ended', onVideoEnded);
    }
    thumbstrip.classList.remove('hh-yt__thumbstrip--hidden');
    if (prevBtn) prevBtn.style.display = '';
    if (nextBtn) nextBtn.style.display = '';
    if (counter) counter.style.display = '';
    if (timerEl) timerEl.style.display = '';
  }

  function onVideoProgress() {
    if (!videoEl || !videoEl.duration) return;
    var pct = (videoEl.currentTime / videoEl.duration) * 100;
    progFill.style.transition = 'none';
    progFill.style.width = pct + '%';
    if (timerEl) {
      timerEl.style.display = '';
      timerEl.textContent = formatTime(videoEl.currentTime * 1000) + ' / ' + formatTime(videoEl.duration * 1000);
    }
  }

  function onVideoEnded() {
    if (autoplayOn && currentArticle < articles.length - 1) {
      /* Autoplay: advance to next article */
      loadArticle(currentArticle + 1);
    } else {
      /* Autoplay off (or last article): stop at the end */
      isPlaying = false;
      updatePlayIcon();
      if (videoEl) videoEl.pause();
      progFill.style.width = '100%';
    }
  }

  function toggleVideoPlay() {
    if (!videoEl) return;
    if (videoEl.paused) {
      videoEl.play().catch(function () {});
      isPlaying = true;
    } else {
      videoEl.pause();
      isPlaying = false;
    }
    updatePlayIcon();
  }


  /* ====================================================================
     SLIDESHOW ENGINE
     ==================================================================== */

  function showSlide(index, images) {
    if (!images.length) return;
    currentSlide = ((index % images.length) + images.length) % images.length;
    slideElapsed = 0; /* reset per-slide timer */

    var incoming, outgoing;
    if (activeLayer === 'a') {
      incoming = slideB;
      outgoing = slideA;
      activeLayer = 'b';
    } else {
      incoming = slideA;
      outgoing = slideB;
      activeLayer = 'a';
    }

    /* Remove old Ken Burns from outgoing */
    clearKB(outgoing);

    /* Set new image */
    incoming.src = images[currentSlide];
    incoming.alt = articles[currentArticle].title + ' — photo ' + (currentSlide + 1);

    /* Apply Ken Burns to incoming */
    clearKB(incoming);
    /* Force reflow so animation restarts */
    void incoming.offsetWidth;
    incoming.classList.add(getRandomKB());

    /* Crossfade */
    incoming.classList.add('is-active');
    outgoing.classList.remove('is-active');

    /* Update counter */
    counter.textContent = (currentSlide + 1) + ' / ' + images.length;

    /* Update thumbstrip active */
    $$('.hh-yt__thumbstrip-item').forEach(function (el, i) {
      el.classList.toggle('is-active', i === currentSlide);
    });

    /* Scroll active thumb into view */
    var activeTh = $('.hh-yt__thumbstrip-item.is-active');
    if (activeTh && thumbstrip) {
      activeTh.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function nextSlide() {
    var images = articles[currentArticle].images;
    showSlide(currentSlide + 1, images);
  }

  function prevSlide() {
    var images = articles[currentArticle].images;
    showSlide(currentSlide - 1, images);
  }

  function startSlideshow() {
    stopSlideshow();
    isPlaying = true;
    updatePlayIcon();
    startTick();
  }

  function stopSlideshow() {
    isPlaying = false;
    updatePlayIcon();
    stopTick();
    if (slideTimer) {
      clearInterval(slideTimer);
      slideTimer = null;
    }
  }

  function togglePlay() {
    if (isVideoMode) {
      toggleVideoPlay();
      return;
    }
    if (isPlaying) {
      stopSlideshow();
    } else {
      startSlideshow();
    }
  }

  function updatePlayIcon() {
    if (!iconPlay || !iconPause) return;
    iconPlay.style.display  = isPlaying ? 'none' : '';
    iconPause.style.display = isPlaying ? '' : 'none';
  }


  /* ====================================================================
     LOAD ARTICLE
     ==================================================================== */

  function loadArticle(index) {
    if (index < 0 || index >= articles.length) return;
    currentArticle = index;
    currentSlide = 0;
    activeLayer = 'a';
    slideElapsed = 0;

    var article = articles[index];

    /* Always exit video mode first */
    exitVideoMode();

    /* Reset both layers */
    slideA.classList.remove('is-active');
    slideB.classList.remove('is-active');
    clearKB(slideA);
    clearKB(slideB);
    slideA.src = '';
    slideB.src = '';

    /* Check if this article has a video */
    if (article.video) {
      enterVideoMode(article.video);

      /* Update info */
      titleEl.textContent = article.title;
      dateEl.textContent = article.date || '';
      authorEl.textContent = article.author || '';
      setDescription(article.excerpt || '');

      /* Build empty thumbstrip */
      thumbstrip.innerHTML = '';

      /* Counter shows "Video" */
      counter.textContent = 'Video';

      /* Update playlist active states */
      playlistItems.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });

      /* Scroll active playlist item into view */
      scrollPlaylistToActive(index);

      /* Mobile: scroll to player */
      if (isMobile) scrollToPlayer();
      return;
    }

    /* ── Photo mode ── */

    /* Show first image on layer A with Ken Burns */
    if (article.images.length) {
      slideA.src = article.images[0];
      slideA.alt = article.title + ' — photo 1';
      clearKB(slideA);
      void slideA.offsetWidth;
      slideA.classList.add(getRandomKB());
      slideA.classList.add('is-active');
    }

    /* Update progress bar */
    progFill.style.transition = 'none';
    progFill.style.width = '0%';

    /* Update counter */
    counter.textContent = article.images.length ? '1 / ' + article.images.length : '0 / 0';

    /* Update timer */
    var totalDuration = (article.images.length || 1) * SLIDE_DURATION;
    if (timerEl) {
      timerEl.textContent = '0:00 / ' + formatTime(totalDuration);
    }

    /* Update info */
    titleEl.textContent = article.title;
    dateEl.textContent = article.date || '';
    authorEl.textContent = article.author || '';
    setDescription(article.excerpt || '');

    /* Build thumbstrip */
    thumbstrip.innerHTML = '';
    article.images.forEach(function (url, i) {
      var div = document.createElement('div');
      div.className = 'hh-yt__thumbstrip-item' + (i === 0 ? ' is-active' : '');
      div.setAttribute('data-slide', i);

      var img = document.createElement('img');
      img.src = url.indexOf('?') > -1
        ? url.replace(/width=\d+/, 'width=128')
        : url;
      img.alt = 'Photo ' + (i + 1);
      img.loading = 'lazy';

      div.appendChild(img);
      thumbstrip.appendChild(div);
    });

    /* Update playlist active states */
    playlistItems.forEach(function (el, i) {
      el.classList.toggle('is-active', i === index);
    });

    scrollPlaylistToActive(index);

    /* Mobile: scroll to player */
    if (isMobile) scrollToPlayer();

    /* Always start slideshow (Ken Burns runs even on single images) */
    startSlideshow();
  }

  function scrollPlaylistToActive(index) {
    var activeItem = playlistItems[index];
    if (activeItem) {
      activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function scrollToPlayer() {
    if (playerEl) {
      /* Scroll the page so the player is at the top */
      var rect = playerEl.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var headerHeight = 70; /* approximate header height */
      window.scrollTo({
        top: scrollTop + rect.top - headerHeight,
        behavior: 'smooth'
      });
    }
  }


  /* ====================================================================
     DESCRIPTION EXPAND / COLLAPSE
     ==================================================================== */

  function setDescription(text) {
    if (!descText) return;
    descText.textContent = text;

    /* Reset to collapsed */
    descWrap.classList.remove('is-expanded');
    if (descToggle) descToggle.style.display = 'none';

    if (!text) {
      descWrap.style.display = 'none';
      return;
    }

    descWrap.style.display = '';

    /* After rendering, check if text is truncated (needs "Show more") */
    requestAnimationFrame(function () {
      if (descText.scrollHeight > descText.clientHeight + 2) {
        descToggle.style.display = '';
        descToggle.textContent = 'Show more';
      }
    });
  }

  if (descToggle) {
    descToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = descWrap.classList.toggle('is-expanded');
      descToggle.textContent = expanded ? 'Show less' : 'Show more';
    });
  }

  /* Clicking the desc box itself also toggles */
  if (descWrap) {
    descWrap.addEventListener('click', function (e) {
      if (e.target === descToggle) return; /* handled above */
      var expanded = descWrap.classList.toggle('is-expanded');
      if (descToggle) descToggle.textContent = expanded ? 'Show less' : 'Show more';
    });
  }


  /* ====================================================================
     EVENT LISTENERS
     ==================================================================== */

  /* Playlist item clicks */
  playlistItems.forEach(function (el) {
    el.addEventListener('click', function () {
      var idx = parseInt(el.getAttribute('data-index'), 10);
      loadArticle(idx);
    });
  });

  /* Control buttons */
  if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
  if (prevBtn) prevBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    if (isVideoMode) return;
    prevSlide();
    if (isPlaying) startSlideshow();
  });
  if (nextBtn) nextBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    if (isVideoMode) return;
    nextSlide();
    if (isPlaying) startSlideshow();
  });

  /* Autoplay toggle */
  if (autoplayBtn) {
    autoplayBtn.addEventListener('click', function () {
      autoplayOn = !autoplayOn;
      autoplayBtn.classList.toggle('is-on', autoplayOn);
    });
  }

  /* Thumbstrip clicks (event delegation) */
  thumbstrip.addEventListener('click', function (e) {
    var item = e.target.closest('.hh-yt__thumbstrip-item');
    if (!item) return;
    var slideIdx = parseInt(item.getAttribute('data-slide'), 10);
    showSlide(slideIdx, articles[currentArticle].images);
    if (isPlaying) startSlideshow(); /* reset timer */
  });

  /* Player click — desktop: toggle play/pause, mobile: tap to show/hide controls */
  var controlsEl = $('.hh-yt__controls');
  var mobileControlsTimeout = null;

  function showMobileControls() {
    if (!controlsEl) return;
    controlsEl.classList.add('is-visible');
    clearTimeout(mobileControlsTimeout);
    mobileControlsTimeout = setTimeout(function () {
      controlsEl.classList.remove('is-visible');
    }, 3500); /* auto-hide after 3.5s */
  }

  function hideMobileControls() {
    if (!controlsEl) return;
    controlsEl.classList.remove('is-visible');
    clearTimeout(mobileControlsTimeout);
  }

  if (playerEl) {
    playerEl.addEventListener('click', function (e) {
      if (e.target.closest('button') || e.target.closest('.hh-yt__counter') || e.target.closest('.hh-yt__timer')) return;

      if (isMobile) {
        /* On mobile, tap toggles controls visibility */
        if (controlsEl && controlsEl.classList.contains('is-visible')) {
          hideMobileControls();
        } else {
          showMobileControls();
        }
      } else {
        togglePlay();
      }
    });
  }

  /* Keyboard navigation */
  document.addEventListener('keydown', function (e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

    switch (e.key) {
      case 'ArrowRight':
        e.preventDefault();
        if (isVideoMode) { if (videoEl) videoEl.currentTime = Math.min(videoEl.currentTime + 5, videoEl.duration); }
        else { nextSlide(); if (isPlaying) startSlideshow(); }
        break;
      case 'ArrowLeft':
        e.preventDefault();
        if (isVideoMode) { if (videoEl) videoEl.currentTime = Math.max(videoEl.currentTime - 5, 0); }
        else { prevSlide(); if (isPlaying) startSlideshow(); }
        break;
      case ' ':
        e.preventDefault();
        togglePlay();
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (currentArticle < articles.length - 1) loadArticle(currentArticle + 1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (currentArticle > 0) loadArticle(currentArticle - 1);
        break;
    }
  });


  /* ====================================================================
     INIT — Load the first article
     ==================================================================== */

  loadArticle(0);

})();
